import { render, staticRenderFns } from "./CrazyRegulament.vue?vue&type=template&id=876f99dc&"
import script from "./CrazyRegulament.vue?vue&type=script&lang=js&"
export * from "./CrazyRegulament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports